export const EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const PHONE = /^[0-9]{6,14}$/;
export const CIF = /^R?O?[ ]?[0-9]{6,8}$/i;
